/* eslint-disable @typescript-eslint/no-explicit-any */
import type { AssetAccount, DescriptionAsset, MotorVehicleAsset, PropertyAsset } from '@/types';
import { convertPeriod } from '@/helpers/convertPeriod';
import { mapToApi } from '@/mappers';

interface ResidualDebtFields {
  useAssetForResidualDebt?: boolean;
  amountTowardsResidualDebt?: number;
}

const getEndDebtContribution = (data: ResidualDebtFields): number =>
  data.useAssetForResidualDebt === true && data.amountTowardsResidualDebt ? data.amountTowardsResidualDebt : 0;

export const fundsAssets = (data: AssetAccount, applicantIndex: number): any => ({
  applicantIndex,
  assetType: data.type,
  assetAmount: data.value,
  institution: data.institution,
  endDebtContribution: getEndDebtContribution(data),
  towardsPurchase: 0,
});

export const assetProperty = (data: PropertyAsset, applicantIndex: number): any => ({
  applicantIndex,
  propertyValue: data.propertyValue,
  propertyPurpose: data.propertyPurpose,
  rentalIncome: convertPeriod(data.rentalIncome, 'month').amount,
  amountOwed: data.amountOwing,
  mortgageLimit: data.amountOwing,
  line1: data.address.addressLine,
  line2: data.address.addressLine2 ?? '',
  city: data.address.locality,
  state: mapToApi.australianState(data.address.state),
  postCode: data.address.postcode,
  country: 'au',
  liabilityLimit: 0,
  monthlyRepayment: 0,
  id: data.id ?? undefined,
});

export const fundsAssetMotorVehicle = (data: MotorVehicleAsset, applicantIndex: number): any => ({
  applicantIndex,
  assetType: data.type,
  assetAmount: data.value,
  make: data.make,
  model: data.model,
  yearBought: Number(data.yearBought),
  institution: '',
  endDebtContribution: getEndDebtContribution(data),
  towardsPurchase: 0,
});

export const fundsAssetDescription = (data: DescriptionAsset, applicantIndex: number): any => ({
  applicantIndex,
  assetType: data.type,
  assetAmount: data.value,
  assetDescription: data.description,
  institution: '',
  endDebtContribution: getEndDebtContribution(data),
  towardsPurchase: 0,
});
